"use client";

import React from "react";
import ThinHeroSection from "../components/ThinHeroSection";

const FAQHero = () => {
  return (
    <ThinHeroSection
      title="Frequently Asked Questions"
      breadcrumb="Home // FAQ"
    />
  );
};

export default FAQHero;
